import { store } from "@/stores/Store"
import SnackbarMessage from '../models/SnackbarMessage'

const DEFAULT_TIMEOUT_SUCCESS = 4000;
const DEFAULT_TIMEOUT_WARNING = 7000;

class Service {

    public addSuccessMessage(message: string, manualClose: boolean | number = false): void {
        const snackbarMessage = new SnackbarMessage(message, "success", typeof manualClose == 'boolean' ? (manualClose as boolean ? -1 : DEFAULT_TIMEOUT_SUCCESS) : (typeof manualClose == 'number' ? manualClose : DEFAULT_TIMEOUT_SUCCESS));
        store.commit("addSnackbarMessage", snackbarMessage);
    }

    public addErrorMessage(message: string): void {
        const snackbarMessage = new SnackbarMessage(message, "error", -1);
        store.commit("addSnackbarMessage", snackbarMessage);
    }

    public addWarningMessage(message: string, manualClose: boolean | number = false): void {
        const snackbarMessage = new SnackbarMessage(message, "warning", typeof manualClose == 'boolean' ? (manualClose as boolean ? -1 : DEFAULT_TIMEOUT_WARNING) : (typeof manualClose == 'number' ? manualClose : DEFAULT_TIMEOUT_WARNING));
        store.commit("addSnackbarMessage", snackbarMessage);
    }

    public resetMessages(): void {
        store.commit("resetSnackbarMessages");
    }
}

export const SnackbarService: Service = new Service();
